'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withParams = require('../withParams');

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withParams2.default)({ type: 'numeric' }, function (value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return (/^[0-9]*$/.test(value)
  );
});


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/numeric.js
// module id = 834
// module chunks = 0